/** Roles that can access the main dashboard (Home / app-dashboard). */
export function canAccessDashboard(roleId: string | null | undefined): boolean {
  return true;
}

/** Post-login and blocked-dashboard redirect target by role. */
export function getDefaultLandingRoute(roleId: string | null | undefined): string {
  if (canAccessDashboard(roleId)) {
    return '/dashboard';
  }
  if (roleId === '2') {
    return '/access-denied';
  }
  if (roleId === '16') {
    return '/assets-view';
  }
  if (roleId === '17') {
    return '/all-requests';
  }
  if (roleId === '18') {
    return '/appointment';
  }
  return '/all-requests';
}
